import { render, staticRenderFns } from "./CardStagesBlock.vue?vue&type=template&id=c4db0386&scoped=true"
import script from "./CardStagesBlock.vue?vue&type=script&lang=js"
export * from "./CardStagesBlock.vue?vue&type=script&lang=js"
import style0 from "./CardStagesBlock.vue?vue&type=style&index=0&id=c4db0386&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4db0386",
  null
  
)

export default component.exports